module.exports = __webpack_public_path__ + "img/huaian.7a2ed94.png";